import React from "react";
import styled from "styled-components";

import * as S from "@styled";

interface IProcessLinkListProps extends React.HTMLAttributes<HTMLElement> {
    prosessLinks: { name: string, href: string }[];
}

const ProcessLinkList: React.FC<IProcessLinkListProps> = ({
    prosessLinks,
    ...rest
}) => (
    <StyledProcessLinkList {...rest}>
        {prosessLinks.map((p, i) => (
            <li key={i}>
                <S.A
                    href={p.href}
                    title="View"
                    variant={S.LinkTextColor.black}
                    target="__blank"
                    style={{ textDecoration: 'underline'}}
                >
                    {p.name}
                </S.A>
            </li>
        ))}
    </StyledProcessLinkList>
);

export default ProcessLinkList;

const StyledProcessLinkList = styled.ul`
    list-style: none;
    display: grid;
    margin: 0;
    padding: 0;
    margin-top: 19px;
    gap: 21px;
`;